import React from "react"

import useUserAgent from "hooks/useUserAgent"

import ContentfulNavigation from "components/page-components/navigation"
import Seo from "components/seo"
import Icon from "icons"
import InstagramIcon from "icons/instagram-icon"
import AuthorClasses from "./author-classes"
import {
  Container,
  ContainerLeft,
  Name,
  Title,
  Biography,
  Interview,
  InterviewTitle,
  InterviewText,
  SocialMediaText,
  SocialMediaContainer,
  ContainerRight,
  FixedContainer,
  AuthorImage,
  StyledMoreArticles,
} from "./styles"

const Author = ({
  author,
  collectiveMemberData,
  authorArticles,
  firstArticleDate,
  authorClasses,
}) => {
  const {
    name,
    title,
    indexForSearch,
    biography,
    interview,
    image,
    twitter,
    pinterest,
    instagram,
    facebookPage,
    website,
    url,
  } = author

  const defaultTransforms = [
    {
      screenSize: 1024,
      transforms: "c_fit,w_936,h_671,q_auto,fl_lossy,f_auto",
    },
    {
      screenSize: 768,
      transforms: "c_fit,w_750,h_520,q_auto,fl_lossy,f_auto",
    },
    {
      transforms: "c_fit,w_750,h_520,q_auto,fl_lossy,f_auto",
    },
  ]
  const indexedAuthors = [
    "aaron-aexander",
    "julie-piatt",
    "kelly-leveque",
    "sarah-starr",
    "peter-crone",
    "dr-amy-shah",
    "cristen-barker",
    "william-cole-dc",
    "katie-reed",
    "dr-frank-lipman",
    "dr-kellyann-petrucci",
    "elise-joan",
    "the-astrotwins",
    "jackson-mackenzie",
    "chrissy-harmon",
    "gabrielle-harris",
    "mandy-morris",
    "myla-kabat-zinn",
    "dr-jolene-brighten",
    "sheryl-paul",
    "tamal-dodge",
    "marvin-singh-m-d",
    "rich-roll",
    "alisa-vitti",
    "dr-ellen-vora",
    "sarah-regan",
    "dr-mark-hyman",
    "vincent-m-pedre-md",
    "dr-robert-rountree",
    "deepak-chopra",
    "dr-aviva-romm",
    "dr-robin-berzin",
  ]
  const backDate = new Date()
  backDate.setMonth(backDate.getMonth() - 2)
  const backDateIsoDate = backDate.toISOString()

  const robots =
    indexForSearch || firstArticleDate > backDateIsoDate || indexedAuthors.includes(url)
      ? "index"
      : "noindex"

  const containSocialMedia = instagram || facebookPage || website || pinterest || twitter

  const isSearchBot = useUserAgent()

  return (
    <>
      <Seo
        title={`${author.name} on mindbodygreen`}
        description={`Articles, podcasts, and video classes from ${author.name} on mindbodygreen.`}
        robots={robots}
        canonical={`${process.env.GATSBY_LOCAL_SITE}/wc/${url}`}
      />
      <ContentfulNavigation />
      <Container>
        <ContainerLeft>
          <Name>{name}</Name>
          <Title>{title}</Title>
          <Biography dangerouslySetInnerHTML={{ __html: biography }} />
          {containSocialMedia && (
            <>
              {(website || instagram || facebookPage || twitter || pinterest) && (
                <SocialMediaText>connect with {name}</SocialMediaText>
              )}
              <SocialMediaContainer>
                {instagram && (
                  <a
                    href={`https://www.instagram.com/${instagram}`}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <InstagramIcon height={20} width={20} title={`Visit ${name} on instagram`} />
                  </a>
                )}
                {facebookPage && (
                  <a href={facebookPage} target="_blank" rel="noreferrer">
                    <Icon
                      id="facebook-icon"
                      width={18}
                      height={18}
                      title={`Visit ${name} on facebook`}
                      color="#3b5998"
                    />
                  </a>
                )}
                {twitter && (
                  <a href={`https://twitter.com/${twitter}`} target="_blank" rel="noreferrer">
                    <Icon
                      id="twitter-icon"
                      width={20}
                      height={20}
                      title={`Visit ${name} on twitter`}
                      color="#4099ff"
                    />
                  </a>
                )}
                {pinterest && (
                  <a
                    href={`https://www.pinterest.com/${pinterest}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon
                      id="pinterest-icon"
                      width={20}
                      height={20}
                      title={`Visit ${name} on pinterest`}
                      color="#bd081c"
                    />
                  </a>
                )}
                {website && (
                  <a href={website} target="_blank" rel="noreferrer">
                    <Icon
                      id="website-icon"
                      height={20}
                      width={20}
                      title={`Visit ${name} on website`}
                    />
                  </a>
                )}
              </SocialMediaContainer>
            </>
          )}
          {interview && Boolean(collectiveMemberData) && (
            <Interview>
              <InterviewTitle>Q&amp;A</InterviewTitle>
              <InterviewText dangerouslySetInnerHTML={{ __html: interview }} />
            </Interview>
          )}
        </ContainerLeft>
        <ContainerRight>
          <FixedContainer>
            {(collectiveMemberData?.image || image) && (
              <AuthorImage
                images={defaultTransforms}
                baseUrl={collectiveMemberData?.image ? collectiveMemberData.image : image}
                lazy={false}
              />
            )}
          </FixedContainer>
        </ContainerRight>
      </Container>

      {authorClasses?.length > 0 && <AuthorClasses classes={authorClasses} author={author} />}
      {authorArticles?.length > 0 && (
        <StyledMoreArticles
          title="Articles"
          articles={authorArticles.map((article) => ({
            ...article,
            previewImage: JSON.stringify(article.previewImage),
          }))}
          loadImmediately={isSearchBot}
          pageType="Article Archive"
        />
      )}
    </>
  )
}

export default Author
